import type { IntegrationProviders } from '@vy/types';
import type { Nullable } from '@vy/utils';
import type { FC, ReactNode } from 'react';
import React, { createContext, useCallback, useState } from 'react';

type IntegrationsContextType = {
  selectedIntegration: Nullable<IntegrationProviders>;
  clearSelectedIntegration: () => void;
  setSelectedIntegration: (provider: IntegrationProviders) => void;
};

export const IntegrationsContext = createContext<IntegrationsContextType>({
  selectedIntegration: null,
  setSelectedIntegration: () => {},
  clearSelectedIntegration: () => {},
});

type IntegrationsContextProviderProps = {
  children: ReactNode;
};

export const IntegrationsContextProvider: FC<IntegrationsContextProviderProps> = ({ children }) => {
  const [selectedIntegration, setSelectedIntegration] = useState<IntegrationProviders | null>(null);

  const clearSelectedIntegration = useCallback(() => setSelectedIntegration(null), [setSelectedIntegration]);

  return (
    <IntegrationsContext.Provider
      value={{ selectedIntegration, clearSelectedIntegration, setSelectedIntegration }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
};
